/*
 * ---------------------------------------------------------------------
 * System Action Types
 * ---------------------------------------------------------------------
 */
export const SET_MINIEVENT_CODE_VALID = "SET_MINIEVENT_CODE_VALID";
